/* =========================================================
   KONST PAGE ANIMATIONS
   Shared scroll / reveal animations
   Applies to Order Builder + Gift Builder
   Safe for late-rendered DOM (AJAX / PageFly)
========================================================= */

(function () {
  if (!('IntersectionObserver' in window)) return;

  const ANIMATED = 'konst-animated';
  const OBSERVED = 'konst-observing';

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      if (el.classList.contains(ANIMATED)) return;

      el.classList.add(ANIMATED);
      observer.unobserve(el);
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -10% 0px'
  });

  function scan() {
    document
      .querySelectorAll('[data-konst-animate]:not(.' + OBSERVED + ')')
      .forEach(el => {
        el.classList.add(OBSERVED);
        observer.observe(el);
      });
  }

  // Initial scan
  scan();

  // Watch for AJAX / PageFly / builder renders
  const mo = new MutationObserver(scan);
  mo.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
